import { render, staticRenderFns } from "./BodyAngleBar.vue?vue&type=template&id=cda25aa2&scoped=true&"
import script from "./BodyAngleBar.vue?vue&type=script&lang=js&"
export * from "./BodyAngleBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda25aa2",
  null
  
)

export default component.exports